import { provideEffects } from "@ngrx/effects";
import { provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { exportTemplatesFeatureKey, exportTemplatesReducer, exportRequestsFeatureKey, exportRequestsReducer, toggleFeatureFeatureKey, toggleFeatureReducer, exportRequestChildrenMapFeatureKey, exportRequestChildrenMapReducer, stationTRagsFeatureKey, stationTagsReducer, ExportTemplatesEffect, ExportRequestsEffect, LoaderEffect, FeedbackEffect, ExportRequestChildrenEffect, StationTagsEffect } from "app/store";
import { StationsEffect } from "app/store/stations/stations.effects";
import { stationsFeatureKey, stationsReducer } from "app/store/stations/stations.reducer";
import {SubscriptionsEffect} from '../../store/subscriptions/subscriptions.effects';
import {subscriptionsFeatureKey, subscriptionsReducer} from '../../store/subscriptions/subscriptions.reducer';

export const provideAppStore = () => [
  provideStore({
    [exportTemplatesFeatureKey]: exportTemplatesReducer,
    [exportRequestsFeatureKey]: exportRequestsReducer,
    [stationsFeatureKey]: stationsReducer,
    [toggleFeatureFeatureKey]: toggleFeatureReducer,
    [exportRequestChildrenMapFeatureKey]: exportRequestChildrenMapReducer,
    [stationTRagsFeatureKey]: stationTagsReducer,
    [subscriptionsFeatureKey]: subscriptionsReducer,
  }),
  provideEffects([
    ExportTemplatesEffect,
    ExportRequestsEffect,
    StationsEffect,
    LoaderEffect,
    FeedbackEffect,
    ExportRequestChildrenEffect,
    StationTagsEffect,
    SubscriptionsEffect
  ]),
  provideStoreDevtools({ maxAge: 25 }),
];
